import RepeaterAPI from './repeater-api';

export default RepeaterAPI;
